import AppointmentCategories from './AppointmentCategories'

export default AppointmentCategories